import React from 'react';
import PropTypes from 'prop-types';

import { css, withStyles, withStylesPropTypes } from 'airbnb-dls-web/build/themes/withStyles';

const propTypes = {
  ...withStylesPropTypes,
  children: PropTypes.node.isRequired,
};

function CenterText({ children, styles }) {
  return <div {...css(styles.text)}>{children}</div>;
}

CenterText.propTypes = propTypes;

export default withStyles(() => ({
  text: {
    textAlign: 'center',
  },
}))(CenterText);



// WEBPACK FOOTER //
// ./src/components/CenterText.jsx